module.exports = "/assets/js/f95c4adbde5029750ec9d1a1c76dca56.svg";